module.exports = __webpack_public_path__ + "media/images/home-banners/lightscape-735108-unsplash-c7786dd531ceef9c1b31ff17c7137bd5.jpg";